import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryTabs() {
  const location = useLocation();
  const currentSlug = location.pathname.startsWith('/category/')
    ? location.pathname.replace('/category/', '')
    : 'all';

  return (
    <div className="flex items-center gap-1 flex-wrap">
      {categories.map((cat) => {
        const isActive = cat.slug === currentSlug;
        const href = cat.slug === 'all' ? '/' : `/category/${cat.slug}`;

        return (
          <Link
            key={cat.id}
            to={href}
            className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
              isActive
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
            }`}
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className={`${cat.icon} text-sm`}></i>
            </div>
            {cat.name}
          </Link>
        );
      })}
    </div>
  );
}